<template>
  <div class="list">
    <div class="title">
      <div @click="handleReturn" class="retBtn">
        <img src="../../../assets/img/back@3x.png" alt="">
      </div>
      <div>人员日常维护</div>
    </div>
    <div class="seach">
      <span class="seachTitle">姓名:</span>
      <input class="seachInput" type="text" placeholder="请输入姓名" v-model="search.name">
      <button class="seachBtn" @click="handleSearch()">搜索</button>
    </div>
    <div v-show="list.length == 0" style="text-align: center;margin-top: 50%;">暂无数据</div>
    <ul
      v-show="list.length != 0"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <li @click="handleDetail(item)" class="personal-list" v-for="item in list" :key="item.id">
        <div class="company-box">
          <span>公司名称：</span>
          <span>{{item.companyName}}</span>
        </div>
        <div class="personal-info">
          <div class="name-box">
            <span>姓名：</span>
            <span>{{item.name}}</span>
          </div>
          <div class="phone-box">
            <span>手机号：</span>
            <span>{{item.phone}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { Indicator } from 'mint-ui';
import { visitorFind } from '@/ajax/apiXB.js'
export default {
  name: "list",
  data() {
    return {
      list:[],
      loading: false,
      search: {
        pageSize: 10,
        startPage: 1,
        name: '',
        phone: '',
        companyName: '',
        firstVisitorStartTime: '',
        lastVisitorStartTime: '',
        userName: '',
        age: '',
        groupParentId: '',
        groupId: '',
        areaName: '',
        stationName: '',
        processName: '',
      },
      endTipsType: false,
      endType: true,
      endType2: false,
    };
  },
  methods: {
    handleReturn () {
      this.$router.go(-1)
    },
    handleRem () {
      var doc = window.document.getElementsByTagName('html')[0]
      var curDeviceWidth = doc.clientWidth || window.innerWidth
      doc.style.fontSize = curDeviceWidth * (20 / 375) + 'px'
    },
    handleSearch() {
      this.list = []
      this.search.startPage = 1
      this.loadMore()
    },
    loadMore() {
        Indicator.open({
          spinnerType: 'fading-circle'
        });
        this.loading = true;
        visitorFind({
          pageSize: 10,
          startPage: this.search.startPage,
          name: this.search.name,
          phone: this.search.phone,
          companyName: this.search.companyName,
          firstVisitorStartTime: this.search.firstVisitorStartTime,
          lastVisitorStartTime: this.search.lastVisitorStartTime,
          userName: this.search.userName,
          age: this.search.age,
          groupParentId: this.search.groupParentId,
          groupId: this.search.groupId,
          areaName: this.search.areaName,
          stationName: this.search.stationName,
          processName: this.search.processName,
          userName: this.userName
        }).then((res) => {
          if(res.code == 1001){
            this.loading = false;
            this.endType2 = false;
            this.search.startPage++;
            if(res.data.pageModel.length==0){
                this.loading = true;
                this.endType = false
                this.endType2 = true
            } else {
              this.list = this.list.concat(res.data.pageModel)
            }
          } else {
            this.$alert({
              title: '错误',
              content: res.msg,
            })
          }
          Indicator.close();
        })
    },
    handleDetail(val) {
      this.$router.push({
        path: '/personalEdit', 
        query: {
          'id': val.id,
          'outHRMgangqun': val.companyName,
          'isVip': val.isVip,
        }
      })
    }
  },
  mounted () {
    this.handleRem()
    let userLoginInfo = JSON.parse(localStorage.getItem('userLoginInfo'))
    this.userName = userLoginInfo.gacCode
    this.companyName = userLoginInfo.userType == 'Y' ? '' : userLoginInfo.companyName
    this.loadMore()
  },
};
</script>
<style lang="scss" scoped>
  .list {
    .title {
      width: 100%;
      line-height: 3rem;
      background: #154B97;
      color: #fff;
      padding-left: 1rem;
      font-weight: 900;
      font-size: 1rem;
      display: flex;
      align-items: center;
      .retBtn {
        height: 3rem;
        width: 1.3rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: .7rem;
        }
      }
    }
    .seach {
      height: 2.3rem;
      border-bottom: 1px solid #F5F5F5;
      display: flex;
      align-items: center;
      .seachTitle {
        padding-left: 1.5rem;
        font-size: .8rem;
      }
      .seachInput {
        border: 1px solid #F5F5F5;
        width: 10rem;
        height: 1.4rem;
        line-height: 1.4rem;
        border-radius: .8rem;
        padding: 0 .5rem;
        margin: 0 .5rem;
        font-size: .6rem;
      }
      .seachBtn {
        width: 2.5rem;
        padding: .25rem .5rem;
        font-size: .6rem;
        color: #fff;
        background: #154B97;
        border-radius: .4rem;
      }
    }
    ul {
      position: relative;
      .endTips2 {
        position: absolute;
        bottom: .5rem;
        width: 100%;
        line-height: 1.2rem;
        text-align: center;
        color: #bbb;
        font-size: .6rem;
        height: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .personal-list:last-child {
        margin-bottom: 1.2rem;
      }
      .personal-list {
        border-bottom: 1px solid #F5F5F5;
        // height: 2.4rem;
        width: 100%;
        padding: .5rem 0 .5rem 1.5rem; 
        cursor: pointer;
        .company-box {
          line-height: 1.5rem;
          span:first-child {
            color: #666;
            font-size: .7rem;
          }
          span:last-child {
            color: #333;
            font-size: .7rem;
          }
        }
        .personal-info {
          line-height: 1.5rem;
          display: flex;
          .name-box {
            width: 7.5rem;
            span:first-child {
              color: #666;
              font-size: .7rem;
            }
            span:last-child {
              color: #333;
              font-size: .7rem;
            }
          }
          .phone-box {
            span:first-child {
              color: #666;
              font-size: .7rem;
            }
            span:last-child {
              color: #333;
              font-size: .7rem;
            }
          }
        }
      }
    }
  }
</style>
